export default __webpack_public_path__ + "static/media/3.eb37d03d.svg";